import { z } from 'zod';
/**
 * Concerns heard from citizens (docs/18-concerns-and-messages.md). The report of an activity
 * names up to three, each under a topic from an admin-managed list (Temat e shqetësimeve), so
 * thousands of reports add up to a picture of the country, branch by branch.
 */
const name = z.string().trim().min(2, 'Emri duhet të ketë të paktën 2 shkronja.').max(100);
export const concernTopicCreateSchema = z.object({ name });
export const concernTopicUpdateSchema = z.object({
    name: name.optional(),
    isActive: z.boolean().optional(),
});
export const concernQuerySchema = z.object({
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
    countyId: z.string().uuid().optional(),
    municipalityId: z.string().uuid().optional(),
    unitId: z.string().uuid().optional(),
    countryCode: z.string().length(2).optional(),
    topicId: z.string().uuid().optional(),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
//# sourceMappingURL=concern.js.map